export const GET_USER_PROJECTS = 'GET_USER_PROJECTS';

export const GET_FOLDER_CONTENT = 'GET_FOLDER_CONTENT';
